<template>
  <m-card
    :class="{ 'cursor-pointer': readOnly }"
    sr-label="View Investigation Request"
    @click="investigationRequestOverview()"
  >
    <div
      :class="[
        {
          clickable: !readOnly,
          'marked-incorrect': entry.data.isMarkedIncorrect,
        },
      ]"
    >
      <m-layout-stack horizontal>
        <div class="flex-auto">
          <span
            ><b>Investigation request:</b>
            {{ entry.data.investigationRequestItems.join(" • ") }}</span
          >
          <span v-if="entry.data.requestedBy"> • {{ entry.data.requestedBy }}</span>
        </div>
        <i v-if="entry.data.isRetrospectivelyAmended" style="white-space: nowrap">{{
          formatRetrospectivelyAmendedLabel(entry.data)
        }}</i>
        <m-badge v-if="entry.data.isAwaitingResults" text="Awaiting Results" amber />
      </m-layout-stack>
      <div
        v-if="
          entry.data.hiddenFromPatientFacingServices ||
          entry.data.confidentialFromThirdParties ||
          entry.data.linkedProblems.length
        "
      >
        <span class="secondary-text">
          {{ getConfidentialityTextAndLinkedProblems() }}
        </span>
      </div>
      <m-separator v-if="entry.data.additionalInformation" class="m-my-xs" />
      <span v-if="entry.data.additionalInformation">
        {{ entry.data.additionalInformation }}
      </span>
    </div>
  </m-card>
</template>
<script setup lang="ts">
import MCard from "../../MCard";
import { PatientJournalRecord } from "../types";
import { openSlideover } from "../../../../composables/dialog/drawer";
import MSeparator from "../../MSeparator";
import MBadge from "../../MBadge";

const props = defineProps<{
  entry: PatientJournalRecord;
  readOnly: boolean;
  clickable?: boolean;
}>();

function investigationRequestOverview() {
  return props.readOnly
    ? openSlideover(`/clinical/investigation-request/overview/${props.entry.id}`, {
        close: true,
      })
    : undefined;
}

function getConfidentialityTextAndLinkedProblems() {
  const textArray = [];

  if (props.entry.data.hiddenFromPatientFacingServices) {
    textArray.push("Redacted from Patient Online Access");
  }
  if (props.entry.data.confidentialFromThirdParties) {
    textArray.push("Confidential from Third Parties");
  }

  const text = textArray.join(" • ");

  const problemsArray = props.entry.data.linkedProblems || [];
  const problemDescriptions = problemsArray
    .filter((x) => x.problemCodeDescription)
    .map((x) => x.problemCodeDescription);

  const problemText = problemDescriptions.length
    ? `Linked Problems: ${problemDescriptions.join(", ")}`
    : "";

  const finalTextArray = [text, problemText].filter(Boolean);

  return finalTextArray.length ? finalTextArray.join(" • ") : false;
}

function formatRetrospectivelyAmendedLabel(item) {
  let label = [];
  if (item.isRetrospectivelyAmended) {
    label.push("Edited");
  }

  return label.join(" • ");
}
</script>
